<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Ceny produktů</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm4>
                <productsearch v-model="produkt" label="Hledat produkt"></productsearch>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.datum | formatDate }}</td>
                  <td>
                    <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                      {{ props.item.produkt.nazev }}
                    </router-link>
                  </td>
                  <td>{{ props.item.mena.nazev }}</td>
                  <td class="text-xs-right">{{ props.item.prodejni_cena | formatMoney }} {{ props.item.mena.zkratka }}</td>
                  <td class="text-xs-right"><span v-if="props.item.mena.id==1">{{ props.item.vykupni_cena | formatMoney }} {{ props.item.mena.zkratka }}</span></td>
                  <td><span v-if="props.item.zdroj=='material'">Cena vypočítána z materiálu</span><span v-else>Ceny vypočítána z URL e-shopu</span></td>
                  <td><span v-if="props.item.zvlastni_rezim=='neni'">Bez zvláštního režimu</span><span v-else-if="props.item.zvlastni_rezim=='par_90'">Par. 90</span><span v-else>Par. 92</span></td>
                  <td><span v-if="props.item.sazba_dph!=null">{{ props.item.sazba_dph.nazev }}</span></td>
                  <td class="text-xs-right">{{ props.item.prodejni_cena_bez_dph | formatMoney }} {{ props.item.mena.zkratka }}</td>
                  <td class="text-xs-right"><span v-if="props.item.prodejni_cena_dph>0">{{ props.item.prodejni_cena_dph | formatMoney }} {{ props.item.mena.zkratka }}</span><span v-else>--</span></td>
                  <td class="text-xs-right"><span v-if="props.item.cena_url>0">{{ props.item.cena_url | formatMoney }} €</span></span><span v-else>--</span></td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      updateItem: {},
      headers: [
        { text: 'ID', value: 'id', width: '30px', sortable: false },
        { text: 'Datum', value: 'datum', sortable: false },
        { text: 'Produkt', value: 'produkt', sortable: false},
        { text: 'Měna', value: 'mena', sortable: false},
        { text: 'Prodejní cena', value: 'prodejni_cena', sortable: false, align: "right"},
        { text: 'Výkupní cena', value: 'vykupni_cena', sortable: false, align: "right"},
        { text: 'Zdroj', value: 'zdroj', sortable: false},
        { text: 'Zvláštní režim', value: 'zvlastni_rezim', sortable: false},
        { text: 'Sazba DPH', value: 'sazba_dph_id', sortable: false},
        { text: 'Prodejní cena bez DPH', value: 'prodejni_cena_bez_dph', sortable: false, align: "right"},
        { text: 'DPH', value: 'prodejni_cena_dph', sortable: false, align: "right"},
        { text: 'Cena z URL', value: 'cena_url', sortable: false, align: "right"}
      ],
      loadingTable: true,
      search: "",
      material: null,
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      items: [],
      dialog: false,
      activeItem: null,
      produkt: null
    }
  },
  computed: {
    th () {
      return window.th;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    produkt () {
      this.load();
    },
    pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/produkty-ceny/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        produkt_id: this.produkt
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    showClick (v) {
      this.activeItem = v;
      this.dialog = true;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TestTools/CenyProduktu.vue